import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { relationshipMappingExpression } from './relationship-mapping-expression.js'
export function buildSingleRowMapping(
  allDbFields: SchemaField[],
  _relationshipFields: SchemaField[],
  typeName: string,
  htmlFields: SchemaField[] = []
): string {
  const fieldMappings = allDbFields.map((f) => {
    if (f.type === 'relationship' && !f.multiple) {
      return `      ${f.name}: ${relationshipMappingExpression(f, `row.${f.name}`)}`
    }
    return `      ${f.name}: row.${f.name}`
  })
  const htmlMappings = htmlFields.map((f) => `      ${f.name}Html: row.${f.name}Html`)
  const singleTimestampFields = allDbFields.some((f) => f.name === 'createdAtFormatted')
    ? []
    : [
        `      createdAtFormatted: formatActionDate(row.createdAt)`,
        `      updatedAtFormatted: formatActionDate(row.updatedAt)`
      ]
  const mappings = [
    ...fieldMappings,
    ...htmlMappings,
    ...singleTimestampFields,
    `      createdByUser: row.createdByUser?.id ? { id: row.createdByUser.id, name: row.createdByUser.name, email: row.createdByUser.email } : null`,
    `      updatedByUser: row.updatedByUser?.id ? { id: row.updatedByUser.id, name: row.updatedByUser.name, email: row.updatedByUser.email } : null`
  ].join(',\n')

  return `{\n${mappings}\n    } as unknown as ${typeName}`
}
